import axiosInstance from "@/axios";
import { Loading } from "@/pages/Other/Loading";
import { t } from "i18next";
import { useEffect, useState } from "react";
import axios from "axios";
import { FileText, ClipboardList, UserCheck, CheckCircle2, Sparkles } from "lucide-react";

const getStepIcon = (index) => {
  switch (index) {
    case 0:
      return <FileText className="w-8 h-8 text-blue-500" />;
    case 1:
      return <ClipboardList className="w-8 h-8 text-blue-500" />;
    case 2:
      return <UserCheck className="w-8 h-8 text-blue-500" />;
    default:
      return <ClipboardList className="w-8 h-8 text-blue-500" />;
  }
};

const AdmissionDetails = ({ fetchCourse }) => {
  const [admissionData, setAdmissionData] = useState(null);

  useEffect(() => {
    async function fetchAdmissionData() { 
      try {  
        const response = await axios.get(`${process.env.REACT_APP_LOGIN_API_BASEURL}/json-page/name/admissiondetails`);
        const events = JSON.parse(response.data);
        setAdmissionData(events);
      } catch (error) {
        console.error("Error fetching admission data:", error);
      }
    }
    fetchAdmissionData();
  }, []);

  if (!admissionData) {
    return <div className="text-center text-gray-500 text-lg"><Loading /></div>;
  }

  return (
    <section id="admission" className="admission-section border-t border-gray-100 bg-[#f8fafc]">
      <div className="admission-container max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Title Block */}
        <div className="max-w-3xl mb-12 text-left">
          <span className="pd-badge mb-4">
            <Sparkles size={11} className="text-blue-500 animate-pulse" />
            {t("Guidelines")}
          </span>
          <h2 className="text-4xl font-extrabold text-gray-900 tracking-tight leading-none mt-2">
            {admissionData?.title}
          </h2>
        </div>

        {/* Application Process */}
        <div className="mb-16">
          <div className="max-w-2xl mb-8 text-left">
            <h3 className="text-xl font-bold text-gray-800 tracking-tight">
              {admissionData?.applicationProcess?.heading}
            </h3>
            <p className="text-gray-500 text-sm mt-2 leading-relaxed">
              {admissionData?.applicationProcess?.description}
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8 text-left">
            {admissionData?.applicationProcess?.steps.map((item, index) => (
              <div key={index} className="admission-step-card bg-white border border-gray-100 rounded-3xl p-8 shadow-sm hover:shadow-md transition-shadow duration-200">
                <span className="step-number-badge text-xs font-extrabold bg-blue-50 text-blue-600 rounded-lg px-2.5 py-1 inline-block self-start">{item?.step || `Step ${index + 1}`}</span>
                <div className="flex items-center gap-4 mt-2">
                  <div className="p-3 bg-blue-50/50 rounded-2xl text-blue-600">
                    {getStepIcon(index)}
                  </div>
                  <h4 className="text-[17px] font-bold text-gray-900 leading-tight">
                    {item?.title}
                  </h4>
                </div>
                <p className="text-gray-500 text-sm leading-relaxed mt-4">
                  {item?.description}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Eligibility Criteria */}
        <div>
          <div className="max-w-2xl mb-8 text-left">
            <h3 className="text-xl font-bold text-gray-800 tracking-tight">
              {admissionData?.eligibilityCriteria?.heading}
            </h3>
            <p className="text-gray-500 text-sm mt-2 leading-relaxed">
              For admission into this <strong>{fetchCourse?.CourseName}</strong>, candidates must meet the following criteria:
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-6 text-left">
            {admissionData?.eligibilityCriteria?.criteria?.map((criteria, index) => (
              <div key={index} className="eligibility-card bg-white border border-gray-100 rounded-2xl p-5 flex items-center gap-4 hover:border-emerald-500/30 hover:shadow-md transition-all duration-200">
                <div className="flex-shrink-0 w-8 h-8 bg-emerald-50 rounded-xl flex items-center justify-center text-emerald-600">
                  <CheckCircle2 className="w-4 h-4 stroke-[2.5]" />
                </div>
                <span className="text-gray-700 text-sm font-bold leading-normal">{criteria?.name}</span>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
};

export default AdmissionDetails;
